import { useCallback } from 'react';
import { loadCategoriesAsync } from '../../data-layer/categories/actions';
import {
    selectCategoryCollection,
    selectCategoryCollectionLoading,
} from '../../data-layer/categories/selectors';
import { useDispatch } from '../../data-layer/useDispatch';
import { useSelector } from '../../data-layer/useSelector';
import type { CategoryModel } from '../../data-layer/categories/types';

interface UseCategoriesControllerPayload {
    items: CategoryModel[];
    isLoading: boolean;
    onLoad: VoidFunction;
}

export const useCategoriesController = (namespace: string): UseCategoriesControllerPayload => {
    const dispatch = useDispatch();
    const items = useSelector((state) => selectCategoryCollection(state, namespace));
    const isLoading = useSelector((state) => selectCategoryCollectionLoading(state, namespace));
    const onLoad = useCallback(
        () => dispatch(loadCategoriesAsync(namespace)),
        [dispatch, namespace],
    );

    return { items, isLoading, onLoad };
};
